/**
 * A check-in run and a session resumed from Active Sessions land on the same
 * `/check-in/:patientId/:visitId/*` URLs with the same visit status, so nothing
 * on screen distinguishes them. Active Sessions marks the URL it resumes into;
 * `StepFlow` carries the mark forward so it survives navigation and reloads.
 */
export const ACTIVE_SESSION_PARAM = "activeSession";

export function isActiveSession(searchParams: URLSearchParams): boolean {
  return searchParams.get(ACTIVE_SESSION_PARAM) === "1";
}

/** Appends without re-serialising, so a nested `returnPath` keeps its encoding. */
export function markAsActiveSession(url: string): string {
  const alreadyMarked = new URL(url, "http://placeholder").searchParams.has(
    ACTIVE_SESSION_PARAM
  );

  if (alreadyMarked) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";

  return `${url}${separator}${ACTIVE_SESSION_PARAM}=1`;
}
